// extracted by mini-css-extract-plugin
export default {"page_post":"SinglePost_page_post__IqvvJ","source":"SinglePost_source__wedxm","section__padding":"SinglePost_section__padding__g8t+W","hero-content":"SinglePost_hero-content__R56Km"};